import React, { useState, useEffect } from "react";
import { Box, Container } from "@mui/material";

// Pages
import InvoiceList from "./invoice";
import MyFavorite from "./myfavorite"; // MyLots
import Profile from "./profile";
import { getUser } from "../../Model/LocalStorage";
import { C, CONTAINER, accountRootSx } from "./accountStyles";
import { AccountEmbeddedContext } from "./components/AccountContext";
import AccountHeader, { initialsOf } from "./components/AccountHeader";
import AccountNavigation from "./components/AccountNavigation";



const NAV_ITEMS = [
  { key: "profile", label: "Profile" },
  { key: "lots", label: "My Lots" },
];

/** Name and email already saved at sign-in (read only; nothing is written). */
function savedMember() {
  try {
    const user = getUser();
    return {
      firstname: user?.firstname ? String(user.firstname) : "",
      lastname: user?.lastname ? String(user.lastname) : "",
      email: user?.email ? String(user.email) : "",
    };
  } catch {
    return { firstname: "", lastname: "", email: "" };
  }
}

export default function SidebarMenu() {
  const [selectedContent, setSelectedContent] = useState(
    () => localStorage.getItem("selectedContent") || "profile"
  );

  useEffect(() => {
    localStorage.setItem("selectedContent", selectedContent);
  }, [selectedContent]);

  const renderContent = () => {
    switch (selectedContent) {
      case "profile":
        return <Profile />;
      case "lots":
        return <MyFavorite />;
      case "invoice":
        return <InvoiceList />;
      default:
        return null;
    }
  };

  const member = savedMember();

  return (
    <Box sx={{ ...accountRootSx, bgcolor: C.paper, minHeight: "60vh" }}>
      <AccountHeader
        eyebrow="My Account"
        title={member.firstname ? `Welcome, ${member.firstname}` : "My Account"}
        subtitle={member.email}
        initials={initialsOf(member.firstname, member.lastname)}
      />

      <AccountNavigation items={NAV_ITEMS} value={selectedContent} onChange={setSelectedContent} />

      <Container maxWidth={CONTAINER} sx={{ pt: { xs: 4, md: 7 }, pb: { xs: 8, md: 12 } }}>
        <Box
          role="tabpanel"
          id={`account-panel-${selectedContent}`}
          aria-labelledby={`account-tab-${selectedContent}`}
          tabIndex={0}
          sx={{ outline: "none" }}
        >
          <AccountEmbeddedContext.Provider value={true}>{renderContent()}</AccountEmbeddedContext.Provider>
        </Box>
      </Container>
    </Box>
  );
}
